import React from "react"
import { HelmetProvider } from "react-helmet-async"
import "firebase/auth"
import "firebase/storage"
import './src/assets/style.css'

// Wrap the app in a HelmetProvider so react-helmet-async can keep the document
// <title> and meta tags in sync as the user navigates between pages (SPA
// routing) after the initial server-rendered HTML.
export const wrapRootElement = ({ element }) => (
  <HelmetProvider>{element}</HelmetProvider>
)
